import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { type IModel, type ITridentResource, MountedRelationalDatabaseLinkedService } from 'shell-models-lib';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MountedRelationalDatabaseLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                workspaceId: '*',
                artifactId: '*',
                rootFolder: '*',
            },
            parameters: '*'
        }
    }
})
export class MountedRelationalDatabaseLinkedServiceAdapter extends LinkedServiceAdapter<MountedRelationalDatabaseLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected override toAzureTypeProperties = (
        tridentResource: ITridentResource
    ): Pick<Model.MountedRelationalDatabaseLinkedServiceTypeProperties, 'workspaceId' | 'artifactId'> => {
        return {
            workspaceId: tridentResource.workspaceObjectId,
            artifactId: tridentResource.objectId
        };
    };

    protected modelConstructor(): new () => MountedRelationalDatabaseLinkedService {
        return MountedRelationalDatabaseLinkedService;
    }

    protected model(): IModel {
        return MountedRelationalDatabaseLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(
        linkedService: MountedRelationalDatabaseLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.MountedRelationalDatabaseLinkedService;
        properties.type = Metamodel.modelFor(MountedRelationalDatabaseLinkedService).name;

        properties.typeProperties = {
            workspaceId: this.valueToResource(linkedService, MountedRelationalDatabaseLinkedService.WORKSPACE_ID),
            artifactId: this.valueToResource(linkedService, MountedRelationalDatabaseLinkedService.ARTIFACT_ID),
            rootFolder: this.valueToResource(linkedService, MountedRelationalDatabaseLinkedService.ROOT_FOLDER),
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(
        linkedServiceResource: Model.LinkedServiceResource,
        linkedService: MountedRelationalDatabaseLinkedService
    ): Promise<MountedRelationalDatabaseLinkedService> {
        const properties = linkedServiceResource.properties as Model.MountedRelationalDatabaseLinkedService;
        const typeProperties: Model.MountedRelationalDatabaseLinkedServiceTypeProperties = properties.typeProperties;

        ValueAdapter.toModel(linkedService, MountedRelationalDatabaseLinkedService.WORKSPACE_ID, typeProperties.workspaceId);
        ValueAdapter.toModel(linkedService, MountedRelationalDatabaseLinkedService.ARTIFACT_ID, typeProperties.artifactId);

        return linkedService;
    }
}
